export const formatEntityLabel = (entityOrName, entityId, showId = false) => {
  if (entityOrName && typeof entityOrName === 'object') {
    const name = (entityOrName.EntityName ?? entityOrName.entityName ?? '').toString().trim();
    const id = entityOrName.EntityId ?? entityOrName.entityId;
    if (!showId) return name;
    return id !== undefined && id !== null && id !== '' ? `${name} - ${id}` : name;
  }

  const name = (entityOrName ?? '').toString().trim();
  if (!showId) return name;
  return entityId !== undefined && entityId !== null && entityId !== '' ? `${name} - ${entityId}` : name;
};

export default formatEntityLabel;
